import { useQuery } from '@apollo/client';

import CourseQuery from 'bundles/course-cards/queries/EnterpriseCourseCardCourseQuery.graphql';
import type {
  EnterpriseCourseCardCourseQueryQuery as Query,
  EnterpriseCourseCardCourseQueryQueryVariables as Variables,
} from 'bundles/course-cards/queries/__generated__/EnterpriseCourseCardCourseQuery';
import { mapGraphQLToCourseV1 } from 'bundles/course-cards/utils/courseUtils';
import type CoursesV1 from 'bundles/naptimejs/resources/courses.v1';

type UseCourseDataReturn = {
  loading: boolean;
  error: any;
  course: CoursesV1 | null;
  data: Query | undefined;
};

/**
 * Hook for fetching course data using GraphQL
 *
 * @param courseId - The course ID to fetch data for
 * @returns Object containing loading state, error, mapped course data, and raw GraphQL data
 */
export const useCourseData = (courseId: string | null | undefined): UseCourseDataReturn => {
  const { loading, error, data } = useQuery<Query, Variables>(CourseQuery, {
    variables: { courseId: courseId || '' },
    context: { clientName: 'gatewayGql' },
    skip: !courseId,
  });

  const courseData = data?.Course?.queryById;
  const mappedCourse = courseData ? (mapGraphQLToCourseV1(courseData) as CoursesV1) : null;

  return {
    loading,
    error,
    course: mappedCourse,
    data,
  };
};
